var Config = {
    DEBUG: false,
    LIB_VERSION: '2.59.0'
};

export default Config;
